const STORAGE_KEY = 'ies-fe-weather-op-default-latlng';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

type StoredPayload = {
  lat: number;
  lng: number;
  t: number;
};

function isValidCoords(lat: unknown, lng: unknown): boolean {
  if (typeof lat !== 'number' || typeof lng !== 'number') return false;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return false;
  return lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
}

/**
 * Đọc tọa độ thời tiết “điểm vận hành” đã lưu (sau geolocation thành công).
 * Hết hạn ~7 ngày → coi như không có.
 */
export function readWeatherOperationalPointCache(): { lat: number; lng: number } | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw == null || raw === '') return null;
    const o = JSON.parse(raw) as Partial<StoredPayload>;
    if (!isValidCoords(o.lat, o.lng) || typeof o.t !== 'number') return null;
    if (Date.now() - o.t > MAX_AGE_MS) return null;
    return { lat: o.lat as number, lng: o.lng as number };
  } catch {
    return null;
  }
}

/** Lưu tọa độ sau khi trình duyệt cấp vị trí. */
export function writeWeatherOperationalPointCache(lat: number, lng: number): void {
  if (typeof window === 'undefined') return;
  if (!isValidCoords(lat, lng)) return;
  try {
    const payload: StoredPayload = { lat, lng, t: Date.now() };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* quota / private mode */
  }
}
